export const filingsUrl = 'https://beian.miit.gov.cn/#/Integrated/index';


export const httpUrl = 'https://beta-api.tasow.com';
// export const httpUrl = 'https://test-beta-api.tasow.com';
